/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from 'antd';
import "./style.scss";
import { getMarketData } from "../../services/market";
import { addTokenToWallet } from "../../utils/token";
import { ADDRESS_BSCS_ADDRESS, CERTIK_AUDIT_URL, DOCS_URL, LAUNCHPAD, LOGO_ICON, NFT_URL, TWITTER_URL, REDIT_URL, FACE_URL, YOUTUBE_URL, TELEGRAM_URL, BUILDERS, AIR_DROP, APPLY, XCONNECT, DEFAI } from "../../const/const";
import pdf from "./Tokenomics2.pdf";

const Footer: React.FC = () => {
  const [data, setData] = useState<any>();
  const fetchMarketData = async () => {
    try {
      const res: any = await getMarketData();
      if (res?.succeeded) {
        setData(res?.data);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchMarketData();
  }, []);

  return (
    <div className="footer-layout">
      <div className="layout">
        <div className="inner-layout">
          <footer className="footer">
            <Row className="footer-row">
              <img className="top-left square" alt='' src='/images/footer/square.svg' />
              <img className="top-right square" alt='' src='/images/footer/square.svg' />
              <img className="bottom-left square" alt='' src='/images/footer/square.svg' />
              <img className="bottom-right square" alt='' src='/images/footer/square.svg' />
              <img className="bottom-center square" alt='' src='/images/footer/square.svg' />
              <img className="top-center square" alt='' src='/images/footer/square.svg' />
              <Col className="left" xs={24} sm={24} lg={12}>
                <div className="inner">
                  <img className="logo" alt='' src='/images/header/bscs.svg' />
                  <p className="desc">Please contact us if you have any specific idea or request.</p>
                  <div onClick={() => window.open("https://mail.google.com/mail/?view=cm&fs=1&to=contact@bscs.finance")}
                    className="flex mail">
                    <img alt='' src='/images/footer/mail.svg' />
                    <p>contact@bscs.finance</p>
                  </div>
                  <div className="flex add-bscs">
                    <img className="logo" alt='' src='/images/footer/bscs.svg' />
                    <p className="price">${Number(data?.price).toFixed(3)}</p>
                    <img className="wallet" alt='' src='/images/footer/metamask.svg' />
                    <div onClick={() =>
                      addTokenToWallet({
                        image: LOGO_ICON,
                        address: ADDRESS_BSCS_ADDRESS,
                        symbol: "BSCS",
                        decimals: 18,
                      })
                    } className="add-btn">
                      Add to wallet
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="right" xs={24} sm={24} lg={12}>
                <Row className="right-row" gutter={12}>
                  <Col className="col-resource" xs={12} sm={12} lg={6}>
                    <h4>About</h4>
                    <a href={DOCS_URL} target="_blank" className="resource">
                      DOCS
                    </a>
                    <a href={CERTIK_AUDIT_URL} target="_blank" className="resource">
                      Audit
                    </a>
                    <Link to={'/brand'} className="resource">
                      Brand asset
                    </Link>
                    <Link to={'/verify'} className="resource">
                      BSCS VERIFY
                    </Link>
                    <Link to={pdf} target="_blank" className="resource">
                      TOKENOMICS 2.0
                    </Link>
                  </Col>
                  <Col className="col-resource" xs={12} sm={12} lg={6}>
                    <h4>Product</h4>
                    <a href={LAUNCHPAD} target="_blank" className="resource">
                      launchpad
                    </a>
                    <a href={NFT_URL} target="_blank" className="resource">
                      nft marketplace
                    </a>
                    <a href={XCONNECT} target="_blank" className="resource">
                      xconnect
                    </a>
                    <a href={DEFAI} target="_blank" className="resource">
                      defai
                    </a>
                  </Col>
                  <Col className="col-resource" xs={12} sm={12} lg={6}>
                    <h4>Campaigns</h4>
                    <a href={AIR_DROP} target="_blank" className="resource">
                      Airdrops
                    </a>
                    <a href={BUILDERS} target="_blank" className="resource">
                      ido builders
                    </a>
                    <a href={APPLY} target="_blank" className="resource">
                      apply to launch
                    </a>

                  </Col>
                  <Col className="col-resource" xs={12} sm={12} lg={6}>
                    <h4>Legal</h4>
                    <Link to='/term' target="_blank" className="resource">
                      term
                    </Link>
                    <Link to='/privacy' target="_blank" className="resource">
                      privacy
                    </Link>
                    <Link to='/cookie' target="_blank" className="resource">
                      cookies
                    </Link>
                    <a className="arrow-up" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                      <span className="left-arm"></span>
                      <span className="right-arm"></span>
                      <span className="arrow-slide"></span>
                    </a>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="flex space-between copy">
              <div className="left">
                <a href={REDIT_URL} target="_blank">
                  <img alt="" src="/images/footer/reddit.svg" />
                </a>
                <a href={TWITTER_URL} target="_blank">
                  <img alt="" src="/images/footer/x.svg" />
                </a>
                <a href={TELEGRAM_URL} target="_blank">
                  <img alt="" src="/images/footer/telegram.svg" />
                </a>
                <a href={FACE_URL} target="_blank">
                  <img alt="" src="/images/footer/fb.svg" />
                </a>
                <a href={YOUTUBE_URL} target="_blank">
                  <img alt="" src="/images/footer/youtube.svg" />
                </a>
              </div>
              <div className="right">
                © 2025 bscs.finance. All rights reserved
              </div>
            </div>
          </footer>
        </div>
        <div className="flex space-between copy-mobile">
          <div className="left">
            <a href='#' target="_blank">
              <img alt="" src="/images/footer/reddit.svg" />
            </a>
            <a href='#' target="_blank">
              <img alt="" src="/images/footer/x.svg" />
            </a>
            <a href='#' target="_blank">
              <img alt="" src="/images/footer/telegram.svg" />
            </a>
            <a href='#' target="_blank">
              <img alt="" src="/images/footer/fb.svg" />
            </a>
            <a href='#' target="_blank">
              <img alt="" src="/images/footer/youtube.svg" />
            </a>
          </div>
          <div className="right">
            © 2025 bscs.finance. All rights reserved
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
